import { Directive, HostBinding, ElementRef } from '@angular/core';

@Directive({
  selector: '[odmCarouselItem]'
})
export class CarouselItemDirective {
  @HostBinding('class.tile') tile = true;
  constructor(public element: ElementRef) {}
}
